import _classCallCheck from "C:\\DC_L\\project\\tone-the-ear\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\DC_L\\project\\tone-the-ear\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import * as Decoder from 'midi-file-parser';
import * as Encoder from 'jsmidgen';
import * as Util from './Util';
import { Track } from './Track';
import { parseHeader } from './Header';
/**
 * @class The Midi object. Contains tracks and the header info.
 */

var Midi =
/*#__PURE__*/
function () {
  _createClass(Midi, null, [{
    key: "fromJSON",

    /**
     * Convert JSON to Midi object
     * @param {object} json
     * @static
     * @returns {Midi}
     */
    value: function fromJSON(json) {
      var midi = new Midi();
      midi.header = json.header;
      json.tracks.forEach(function (track) {
        var newTrack = Track.fromJSON(track);
        midi.tracks.push(newTrack);
      });
      return midi;
    }
  }]);

  function Midi() {
    _classCallCheck(this, Midi);

    this.header = {
      //defaults
      bpm: 120,
      timeSignature: [4, 4],
      PPQ: 480
    };
    this.tracks = [];
  }
  /**
   * Load the given url and parse the midi at that url
   * @param  {String}   url
   * @param {*} data Anything that should be sent in the XHR
   * @param {String} method Either GET or POST
   * @return {Promise}
   */


  _createClass(Midi, [{
    key: "load",
    value: function load(url) {
      var _this = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
      return new Promise(function (success, fail) {
        var request = new XMLHttpRequest();
        request.open(method, url);
        request.responseType = 'arraybuffer'; // decode asynchronously

        request.addEventListener('load', function () {
          if (request.readyState === 4 && request.status === 200) {
            success(_this.decode(request.response));
          } else {
            fail(request.status);
          }
        });
        request.addEventListener('error', fail);
        request.send(data);
      }).catch(function (error) {
        console.log(error);
      });
    }
    /**
     * Decode the bytes
     * @param  {String|ArrayBuffer} bytes The midi file encoded as a string or ArrayBuffer
     * @return {Midi}       this
     */

  }, {
    key: "decode",
    value: function decode(bytes) {
      var _this2 = this;

      if (bytes instanceof ArrayBuffer) {
        var byteArray = new Uint8Array(bytes);
        bytes = String.fromCharCode.apply(null, byteArray);
      }

      var midiData = Decoder(bytes);
      this.header = parseHeader(midiData); //replace the previous tracks

      this.tracks = [];
      midiData.tracks.forEach(function (trackData, i) {
        var track = new Track();
        track.id = i;

        _this2.tracks.push(track);

        var absoluteTime = 0;
        trackData.forEach(function (event) {
          absoluteTime += Util.ticksToSeconds(event.deltaTime, _this2.header);

          if (event.type === 'meta' && event.subtype === 'trackName') {
            track.name = Util.cleanName(event.text);
          } else if (event.subtype === 'noteOn') {
            track.noteOn(event.noteNumber, absoluteTime, event.velocity / 127);

            if (track.channelNumber === -1) {
              track.channelNumber = event.channel;
            }
          } else if (event.subtype === 'noteOff') {
            track.noteOff(event.noteNumber, absoluteTime);
          } else if (event.subtype === 'controller' && event.controllerType) {
            track.cc(event.controllerType, absoluteTime, event.value / 127);
          } else if (event.type === 'meta' && event.subtype === 'instrumentName') {
            track.instrument = event.text;
          } else if (event.type === 'channel' && event.subtype === 'programChange') {
            track.patch(event.programNumber);
            track.channelNumber = event.channel;
          }
        }); //if the track is empty, then it is the file name

        if (!_this2.header.name && !track.length && track.name) {
          _this2.header.name = track.name;
        }
      });
      return this;
    }
    /**
     * Encode the Midi object as a Buffer String
     * @returns {String}
     */

  }, {
    key: "encode",
    value: function encode() {
      var _this3 = this;

      var output = new Encoder.File({
        ticks: this.header.PPQ
      });
      var firstEmptyTrack = this.tracks.filter(function (track) {
        return !track.length;
      })[0];

      if (this.header.name && !(firstEmptyTrack && firstEmptyTrack.name === this.header.name)) {
        var track = output.addTrack();
        track.addEvent(new Encoder.MetaEvent({
          time: 0,
          type: Encoder.MetaEvent.TRACK_NAME,
          data: this.header.name
        }));
      }

      this.tracks.forEach(function (track) {
        var trackEncoder = output.addTrack();
        trackEncoder.setTempo(_this3.bpm);

        if (track.name) {
          trackEncoder.addEvent(new Encoder.MetaEvent({
            time: 0,
            type: Encoder.MetaEvent.TRACK_NAME,
            data: track.name
          }));
        }

        track.encode(trackEncoder, _this3.header);
      });
      return output.toBytes();
    }
    /**
     * Convert the output encoding into an Array
     * @return {Array}
     */

  }, {
    key: "toArray",
    value: function toArray() {
      var encodedStr = this.encode();
      var buffer = new Array(encodedStr.length);

      for (var i = 0; i < encodedStr.length; i++) {
        buffer[i] = encodedStr.charCodeAt(i);
      }

      return buffer;
    }
    /**
     *  Convert all of the fields to JSON
     *  @return  {Object}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var ret = {
        header: this.header,
        startTime: this.startTime,
        duration: this.duration,
        tracks: (this.tracks || []).map(function (track) {
          return track.toJSON();
        })
      };
      if (!ret.header.name) ret.header.name = '';
      return ret;
    }
    /**
     * Add a new track.
     * @param {String=} name Optionally include the name of the track
     * @returns {Track}
     */

  }, {
    key: "track",
    value: function track(name) {
      var track = new Track(name);
      this.tracks.push(track);
      return track;
    }
    /**
     * Get a track either by it's name or track index
     * @param  {Number|String} trackName
     * @return {Track}
     */

  }, {
    key: "get",
    value: function get(trackName) {
      if (Util.isNumber(trackName)) {
        return this.tracks[trackName];
      } else {
        return this.tracks.find(function (t) {
          return t.name === trackName;
        });
      }
    }
    /**
     * Slice the midi file between the startTime and endTime. Returns a copy of the
     * midi
     * @param {Number} startTime
     * @param {Number} endTime
     * @returns {Midi} this
     */

  }, {
    key: "slice",
    value: function slice() {
      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.duration;
      var midi = new Midi();
      midi.header = this.header;
      midi.tracks = this.tracks.map(function (t) {
        return t.slice(startTime, endTime);
      });
      return midi;
    }
    /**
     * the time of the first event
     * @type {Number}
     */

  }, {
    key: "startTime",
    get: function get() {
      var startTimes = this.tracks.map(function (t) {
        return t.startTime;
      });
      if (!startTimes.length) return 0;
      return Math.min.apply(Math, startTimes) || 0;
    }
    /**
     * The bpm of the midi file in beats per minute
     * @type {Number}
     */

  }, {
    key: "bpm",
    get: function get() {
      return this.header.bpm;
    },
    set: function set(bpm) {
      var prevTempo = this.header.bpm;
      this.header.bpm = bpm; //adjust the timing of all the notes

      var ratio = prevTempo / bpm;
      this.tracks.forEach(function (track) {
        return track.scale(ratio);
      });
    }
    /**
     * The timeSignature of the midi file
     * @type {Array}
     */

  }, {
    key: "timeSignature",
    get: function get() {
      return this.header.timeSignature;
    },
    set: function set(timeSig) {
      this.header.timeSignature = timeSig;
    }
    /**
     * The duration is the end time of the longest track
     * @type {Number}
     */

  }, {
    key: "duration",
    get: function get() {
      var durations = this.tracks.map(function (t) {
        return t.duration;
      });
      if (!durations.length) return 0;
      return Math.max.apply(Math, durations) || 0;
    }
  }]);

  return Midi;
}();

export { Midi };